import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { AlertService } from 'src/app/services/alert.service';
import { PasswordService } from '../services/password.service';
import { UserService } from '../../services/user.service';
import { CambiarContrasenaService } from '../../services/cambiar-Contrasena.service';
import { SweetAlertService } from '../../services/sweet-alert.service';
import { PASSWORD_COMPLEXITY_PATTERN } from 'src/app/shared/utils/validation.constants';
import { AnalyticsTagService } from 'src/app/services/analytics-tag.service';

declare var $:any;

@Component({
    selector: 'app-cambiar-contrasena',
    templateUrl: './cambiar-contrasena.component.html',
    styleUrls: ['./cambiar-contrasena.component.scss'],
    standalone: false
})
export class CambiarContrasenaComponent implements OnInit {
  idCliente: number;
  isVisible: boolean = false;
  isVisibleNueva: boolean = false;
  isConfirm: boolean = false;
  isLoading: boolean = false;
  validarContrasena = PASSWORD_COMPLEXITY_PATTERN;
  constructor(
    private formBuilder: UntypedFormBuilder,
    private password: PasswordService,
    private CambiarContrasenaService: CambiarContrasenaService,
    private user: UserService,
    private alertaService: AlertService,
    private _sweetAlert:SweetAlertService,
    private _analyticsTag: AnalyticsTagService) { }

     public cambioContraForm = this.formBuilder.group({
      contraActual: ['', [Validators.required, Validators.minLength(8), Validators.pattern(this.validarContrasena)]],
      contraNueva: ['', [Validators.required, Validators.minLength(8), Validators.pattern(this.validarContrasena)]],
      confirContraNueva: ['', Validators.required]
    },{
      validator: [this.password.matchPassword('contraNueva', 'confirContraNueva'), /* this.password.noRepeatPassword('contraActual','contraNueva') */]
    }
    );

  ngOnInit(){
    this.idCliente = this.user.getUser().idUsuario;
  }

  showPassword() {
    this.isVisible = !this.isVisible;
  }
  showPasswordNueva() {
    this.isVisibleNueva = !this.isVisibleNueva;
  }

  showConfirmPassword() {
    this.isConfirm = !this.isConfirm;
  }

  trackVolver(){
    this._analyticsTag.trackCtaClick({
      ctaLabel: 'Volver',
      ctaSection: 'cambiar-contrasena',
      ctaComponent: 'cambiar-contrasena',
      ctaElementId: 'btn-cambiar-contrasena-volver',
      hu: '8337',
    });
  }

  guardarContraNueva(){
    this._analyticsTag.trackCtaClick({
      ctaLabel: 'Guardar',
      ctaSection: 'cambiar-contrasena',
      ctaComponent: 'cambiar-contrasena',
      ctaElementId: 'btn-cambiar-contrasena-guardar',
      hu: '8337',
    });
    const body:any = {
      idUsuario: Number(this.idCliente),
      contraseniaAnterior: this.cambioContraForm.get('contraActual').value,
      contraseniaNueva: this.cambioContraForm.get('contraNueva').value
    }
    this.isLoading = true;
    this.CambiarContrasenaService.getCambioContrasena(body).subscribe((data:any)=>{
      if(data.exitoso == 'true' || data.exitoso === true){
        this.isLoading = false;
        $('#mensajeModal').modal('show');
      }else{
        const mensaje =
          data.error ||
          data.mensajeError ||
          'No fue posible cambiar la contraseña. Inténtalo de nuevo.';
        this._sweetAlert.errorModal("Error!",true, mensaje);
        this.isLoading = false;
      }
    })
  }

  validateField(key: string) {
    return (
        (this.cambioContraForm.get(key).dirty ||
            this.cambioContraForm.get(key)?.touched) &&
        this.cambioContraForm.get(key)?.invalid
    );
}

validateRepeatPassword(key:string, key2:string){
  return (
    (this.cambioContraForm.get(key).value === this.cambioContraForm.get(key2).value)
  );
}

validateForm() {
  if (this.cambioContraForm.valid) {
    this.guardarContraNueva();
  } else {
    this.cambioContraForm.markAllAsTouched();
  }
}

}

